import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '1.0.0',
        navAppTitle: 'Grupo Médico Pediátrico',
        navMainLogo: require('@/assets/gmp2.png'),
        mainLogo: require('@/assets/gmp5.png'),
        bWaitCursor: false,
        bNoResults: false, //Indica si no hubo resultados en una búsqueda de productos.
        bAutorizado: null,
        cartItems: 0, //Número de artículos en el carrito de compras.

        noticias: [],

        //Vinatería:
        selectedWineIndex: -1, //Indice del vino seleccionado en la ventana Vinateria.
        vino: {
            nombre: '',
            tipo: '',
            uva: '',
            region: '',
            pais: '',
            bodega: '',
            descripcion: '',
            notasdecata: '',
            imagen: '',
            rating: 0
        },

        //Licorería:
        selectedLiquorIndex: -1, //Indice del producto seleccionado en la ventana Licorería.
        licor: {
            nombre: '',
            tipo: '',
            pais: '',
            descripcion: '',
            etiqueta: '',
            imagen: '',
            rating: 0
        },

        //Cervecería:
        selectedBeerIndex: -1, //Indice del producto seleccionado en la ventana Cervecería.
        cerveza: {
            nombre: '',
            tipo: '',
            pais: '',
            descripcion: '',
            etiqueta: '',
            imagen: '',
            rating: 0
        },

        paises: [],
        tiposVinos: [],
        tiposLicores: [],
        tiposCervezas: [],
        vinos: [],
        licores: [],
        cervezas: [],
        // vinosTemp: [
        //     {
        //         vinoid: 1,
        //         nombre: 'Monteviña',
        //         bodega: 'Vinícola San Lorenzo',
        //         tipo: 'Tinto',
        //         pais: 'México',
        //         region: 'Valle de Parras',
        //         uva: 'Cabernet Sauvignon-Merlot',
        //         descripcion: 'Vino tinto joven, fermentado en tanques de acero inoxidable, usando el método francés Délestage.',
        //         notasdecata: 'De color rojo cereza. Vino expresivo de aromas francos y limpios, frutos rojos como fresa, grosella, frambuesa y unas notas de rosas y vainilla.',
        //         imagen: require("@/assets/vinateria/montevina.png"),
        //         rating: 4.5
        //     },
        //     {
        //         vinoid: 2,
        //         nombre: 'Vino Tinto Ruby Dulce',
        //         bodega: 'Viñedos La Redonda',
        //         tipo: 'Tinto',
        //         pais: 'México',
        //         region: 'Querétaro',
        //         uva: 'Ruby Cabernet',
        //         descripcion: 'Vino tinto dulce de maduración tardía. Fermentado a baja temperatura para guardar características propias del fruto.',
        //         notasdecata: 'Rojo granate intenso y muy profundo con matices violáceos. Frutos secos como ciruela pasa, higo y especiados como canela. Ataque suave, acidez delicada dulce, cuerpo medio con buen equilibrio.',
        //         imagen: require("@/assets/vinateria/la_redonda.png"),
        //         rating: 3.5
        //     },
        // ],
        platillos: [],
        productosGourmet: []
    },
    mutations: {
        setAutorizado(state, autorizado) {
            state.bAutorizado = autorizado;
            if (state.bAutorizado) {
                router.push('/');
            }
        },
        setCartItems(state, num) {
            state.cartItems = num;
        },
        setNoResults(state, payload) {
            state.bNoResults = payload;
        },
        setPaises(state, paises) {
            state.paises = paises;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.paises.unshift({
                paisid: 0,
                pais: 'Todos'
            });
            state.paises.unshift({
                paisid: -1,
                pais: 'Seleccione'
            });
        },
        setTiposVinos(state, tiposVinos) {
            state.tiposVinos = tiposVinos;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.tiposVinos.unshift({
                tipoid: 0,
                tipo: 'Todos'
            });
            state.tiposVinos.unshift({
                tipoid: -1,
                tipo: 'Seleccione'
            });
        },
        setTiposLicores(state, tiposLicores) {
            state.tiposLicores = tiposLicores;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.tiposLicores.unshift({
                tipoid: 0,
                tipo: 'Todos'
            });
            state.tiposLicores.unshift({
                tipoid: -1,
                tipo: 'Seleccione'
            });
        },
        setTiposCervezas(state, tiposCervezas) {
            state.tiposCervezas = tiposCervezas;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.tiposCervezas.unshift({
                tipoid: 0,
                tipo: 'Todas'
            });
            state.tiposCervezas.unshift({
                tipoid: -1,
                tipo: 'Seleccione'
            });
        },
        cleanWineList(state) {
            state.vinos = [];
            state.selectedWineIndex = -1;
            state.vino = {
                vinoid: 0,
                nombre: '',
                bodega: '',
                tipo: '',
                pais: '',
                region: '',
                uva: '',
                descripcion: '',
                notasdecata: '',
                imagen: '',
                rating: 0
            };
        },
        cleanLiquorList(state) {
            state.licores = [];
            state.selectedLiquorIndex = -1;
            state.licor = {
                licorid: 0,
                nombre: '',
                tipo: '',
                pais: '',
                descripcion: '',
                etiqueta: '',
                imagen: '',
                rating: 0
            };
        },
        cleanBeerList(state) {
            state.cervezas = [];
            state.selectedBeerIndex = -1;
            state.cerveza = {
                cervezaid: 0,
                nombre: '',
                tipo: '',
                pais: '',
                descripcion: '',
                etiqueta: '',
                imagen: '',
                rating: 0
            };
        },
        setNoticias(state, noticias) {
            state.noticias = noticias;
        },
        updateSelectedWineIndex: (state, index) => {
            state.selectedWineIndex = index;
        },
        updateSelectedLiquorIndex: (state, index) => {
            state.selectedLiquorIndex = index;
        },
        updateSelectedBeerIndex: (state, index) => {
            state.selectedBeerIndex = index;
        },
        updateVino: (state, vino) => {
            state.vino = vino;
        },
        updateLicor: (state, licor) => {
            state.licor = licor;
        },
        updateCerveza: (state, cerveza) => {
            state.cerveza = cerveza;
        }
    },
    actions: {
        updateAutorizado({ commit }, autorizado) {
            commit('setAutorizado', autorizado);
        },
        updateCartItems({ commit }, num) {
            commit('setCartItems', num);
        },
        fetchPaises({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/paises/')
                .then(res => {
                    console.log('fetchPaises, paises = ', res.data);
                    state.bWaitCursor = false;
                    commit('setPaises', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchTiposVinos({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tipoVino/')
                .then(res => {
                    console.log('fetchTiposVinos, tipos = ', res.data);
                    state.bWaitCursor = false;
                    commit('setTiposVinos', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchTiposLicores({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tipoLicores/')
                .then(res => {
                    console.log('fetchTiposLicores, tipos = ', res.data);
                    state.bWaitCursor = false;
                    commit('setTiposLicores', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchTiposCervezas({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tipoCervezas/')
                .then(res => {
                    console.log('fetchTiposCervezas, tipos = ', res.data);
                    state.bWaitCursor = false;
                    commit('setTiposCervezas', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchNoticias({ commit, state }, winesQueryData) {
            state.bWaitCursor = true;

            // axios.get('/noticias/', { crossDomain: true }
            //     )
            //     .then(res => {
            //         console.log('fetchNoticias = ', res.data);
            //         state.bWaitCursor = false;
            //         commit('setNoticias', res.data);
            //     })
            //     .catch(error => {
            //         console.log(error);
            //         state.bWaitCursor = false;
            //     });

            //Inicio pruebas:

            var noticias = [
                {
                    titulo: 'Dentista Infantil',
                    texto: 'Consulta servicios en www.gmpediatrico.com.',
                    foto: require('@/assets/yusuf-belek-gHdVUGAJYGo-unsplash.jpg')
                },
                {
                    titulo: 'Consulta de Espeialidad-Adultos y Niños',
                    texto: 'Consulta la lista de especialistas.',
                    foto: require('@/assets/hush-naidoo-jade-photography-yo01Z-9HQAw-unsplash.jpg')
                },
                {
                    titulo:
                        'No somos centro de detección y atención de Covid-19',
                    texto:
                        'Limitaremos el flujo de pacientes. Aplicaremos vacunas a población sana para no atrasar esquemas de vacunación, todos con previa cita en nuestros 3 consultorios. Consulta de especialistas será con horarios específicos . Hablar a pedir citas y consultar horarios.',
                    foto: require('@/assets/mufid-majnun-cM1aU42FnRg-unsplash.jpg')
                },
                {
                    titulo: 'GCB (Tuberculosis)',
                    texto: 'Ya tenemos vacuna DISPONIBLE.',
                    foto: require('@/assets/cdc-9MVMgP2zhgs-unsplash.jpg')
                }
            ];

            commit('setNoticias', noticias);

            state.bWaitCursor = false;
            //Fin pruebas.
        },
        fetchBeers({ commit, state }, beersQueryData) {
            state.bWaitCursor = true;
            //console.log("queryData: ", beersQueryData);

            axios
                .get(
                    '/cervezas/' +
                        beersQueryData.paisID +
                        '/' +
                        beersQueryData.tipoCervezaID,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('fetchBeers, cervezas = ', res.data);
                    state.bWaitCursor = false;
                    commit('setCervezas', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchRestaurante({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/restaurante/', { crossDomain: true })
                .then(res => {
                    console.log('fetchRestaurante, platillos = ', res.data);
                    state.bWaitCursor = false;
                    commit('setPlatillos', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchProductosGourmet({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/gourmet/', { crossDomain: true })
                .then(res => {
                    console.log(
                        'fetchProductosGourmet, productos = ',
                        res.data
                    );
                    state.bWaitCursor = false;
                    commit('setProductosGourmet', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        cleanWineList({ commit }) {
            commit('cleanWineList');
        },
        cleanLiquorList({ commit }) {
            commit('cleanLiquorList');
        },
        cleanBeerList({ commit }) {
            commit('cleanBeerList');
        },
        updateSelectedWineIndex({ commit }, index) {
            commit('updateSelectedWineIndex', index);
        },
        updateSelectedLiquorIndex({ commit }, index) {
            commit('updateSelectedLiquorIndex', index);
        },
        updateSelectedBeerIndex({ commit }, index) {
            commit('updateSelectedBeerIndex', index);
        },
        updateVino({ commit }, vino) {
            commit('updateVino', vino);
        },
        updateLicor({ commit }, licor) {
            commit('updateLicor', licor);
        },
        updateCerveza({ commit }, cerveza) {
            commit('updateCerveza', cerveza);
        },
        updateNoResults({ commit }, payload) {
            commit('setNoResults', payload);
        }
    },
    getters: {
        version: state => {
            return state.version;
        },
        autorizado: state => {
            return state.bAutorizado;
        },
        navAppTitle: state => {
            return state.navAppTitle;
        },
        navMainLogo: state => {
            return state.navMainLogo;
        },
        mainLogo: state => {
            return state.mainLogo;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        noResults: state => {
            return state.bNoResults;
        },
        paises: state => {
            return state.paises;
        },
        tiposVinos: state => {
            return state.tiposVinos;
        },
        tiposLicores: state => {
            return state.tiposLicores;
        },
        tiposCervezas: state => {
            return state.tiposCervezas;
        },
        vinos: state => {
            return state.vinos;
        },
        licores: state => {
            return state.licores;
        },
        cervezas: state => {
            return state.cervezas;
        },
        selectedWineIndex: state => {
            return state.selectedWineIndex;
        },
        selectedLiquorIndex: state => {
            return state.selectedLiquorIndex;
        },
        selectedBeerIndex: state => {
            return state.selectedBeerIndex;
        },
        vino: state => {
            return state.vino;
        },
        licor: state => {
            return state.licor;
        },
        cerveza: state => {
            return state.cerveza;
        },
        platillos: state => {
            return state.platillos;
        },
        productosGourmet: state => {
            return state.productosGourmet;
        },
        cartItems: state => {
            return state.cartItems;
        },
        noticias: state => {
            return state.noticias;
        }
    }
});
